import { PushCardToIntegrationTool } from '@/api/storymapCardDetails/commands';
import { snackbar } from '@/_core/app-components/use';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { Activity, StorymapState, Subtask, Task } from '../types';
import { getIntegrationToolName } from '../use';
import { useStorymapStore } from '../useModule';
import { CardPushedToIntegrationTool } from './cardPushedToIntegrationTool';

const { registerMiddleware, dispatch } = useStorymapStore();

export class PushCardToIntegration extends Action<StorymapState> {
    public static ACTION_TYPE = 'PushCardToIntegration';

    public constructor(public card: Activity | Task | Subtask) {
        super(PushCardToIntegration.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: PushCardToIntegration): Promise<boolean> => {
    action.card.isSaving = true;

    const cmd = await PushCardToIntegrationTool.create(
        action.card.id,
        action.card.title,
        state.id,
        getIntegrationToolName(state.integrationToolType)
    );

    const res = await useSendCommandAsync(action, {
        createCommand: async () => await cmd,
        onSuccess(res) {
            if (res.IsSuccess) {
                dispatch(new CardPushedToIntegrationTool(action.card, res));
                snackbar.showSuccess(res.Message);
            } else {
                snackbar.showError(res.Message);
            }
        },
    });

    action.card.isSaving = false;

    return res;
};

//@ts-ignore
registerMiddleware(PushCardToIntegration.ACTION_TYPE, middleware);
